export let emailTemplate = `
<table class="bmeMainColumn bmeHolder" style="max-width: 600px; overflow: visible; border-radius: 0px; border-collapse: separate; border-spacing: 0px;" border="0" cellspacing="0" cellpadding="0" align="center">
  <tbody>
    <tr id="section_1" class="flexible-section" data-columns="1" data-section-type="bmePreHeader">
      <td class="blk_container bmeHolder" style="color: #666666; border: 0px none transparent;" align="center" valign="top" bgcolor="" width="100%">&nbsp;</td>
    </tr>
    <tr>
      <td class="bmeHolder" style="border: 0px none transparent; border-radius: 0px; border-collapse: separate; border-spacing: 0px; overflow: hidden;" align="center" valign="top" width="100%">
        <table style="border-radius: 0px; border-collapse: separate; border-spacing: 0px; border: 0px none transparent; overflow: visible;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center">
          <tbody>
            <tr id="section_4" class="flexible-section" data-columns="1">
              <td class="blk_container bmeHolder" style="color: #383838; border: 0px none transparent; background-color: #ffffff;" align="center" valign="top" bgcolor="#ffffff" width="100%">
                <div id="dv_4" class="blk_wrapper">
                  <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                    <tbody>
                    <tr>
                    <td>
                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                    <tr>
                    <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                      <div>
                        <div>
                          <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/email1.png">
                        </div>
                        <div style="height: 48px;line-height: 48px;font-weight: bold;font-size:18px">
                          <span style="color:#99c41c">$25 OFF</span> OVER $50 CODE:SAVE25
                        </div>
                        <div style="background-color:#171717;height:350px;position: relative;padding-top: 80px;">
                          <div style="margin-bottom:30px;width:100%">
                            <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/emailCar1.png" style="height:60px;width:60px;display:block;margin:0 auto">
                          </div>
                          <div style="color:#FFFFFF;font-size:24px;line-height:30px;margin-bottom:8px">
                            Don't you. forget about me!
                          </div>
                          <div style="color:#FFFFFF;font-size:14px;width:420px;line-height:20px">
                            Hey, you left something behind. Complete your order today for
                            an extra $25 off (just because we love you).
                          </div>
                        </div>
                      </div>
                    </td>
                    </tr>
                    </tbody>
                    </table>
                    </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div id="dv_8" class="blk_wrapper">
                  <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td>
                        <table border="0" width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                        <tr>
                        <td  style="border-collapse: collapse; padding: 0px;" align="center">
                          <div style="margin: 20px auto">
                              <h2 style="text-align:center;width:100%">YOUR ORDER</h2>
                              <div  class="kakaclo-for-productBasicInfoVOList">
                                <div style="margin: 22px 0 26px;display: flex;justify-content: center;">
                                  <div style="width: 116px;height:146px;background: #D9D9D9;font-weight: bold;margin-right:20px;text-align: center;line-height: 146px;">
                                    \${imageUrl}
                                  </div>
                                  <div style="font-size:8px;margin-top: 24px;text-align: left;width:200px">
                                    <p style="margin-bottom: 4px;white-space: nowrap;">\${productTitle}</p>
                                    <div style="color: #8B93A3;margin-bottom: 4px">\${option}</div>
                                    <p>
                                      <span>$\${price}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div style="width: 210px;line-height:36px;color:#fff;background-color:#E4555B;font-size: 14px">
                                <a href="https://mall.kakaclo.com/order/details?kkOrderId=1000001167055&orderStatus=0" style="text-decoration: none;color: #fff">Finsh check out</a>
                              </div>
                            </div>
                        </td>
                        </tr>
                        </tbody>
                        </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div id="dv_10" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <!-- <a href="https://clt1425789.bmetrack.com/c/l?u=E555663&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=3" target="_blank" rel="noopener"> -->
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819835.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  <!-- </a> -->
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_11" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <a href="https://mall.kakaclo.com/return&refund" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819840.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_3" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <a href="http://www.cxes.site/1HzwCea5" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819832.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_2" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <!-- <a href="https://clt1425789.bmetrack.com/c/l?u=E555663&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=6" target="_blank" rel="noopener"> -->
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819846.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  <!-- </a> -->
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_9" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table class="bmeGroupContainer" style="border-collapse: separate; border-width: 0px; border-style: none; border-color: rgba(0, 0, 0, 0); padding: 0px;" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImageContainerRow" valign="top">
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="left">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555664&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819845.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="left">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555665&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819847.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="right">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555666&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819844.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_34" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="tblCellMain" style="padding: 10px 0px;">
                <table class="tblLine" style="border-top-width: 4px; border-top-color: #282828; border-top-style: solid; min-width: 1px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>&nbsp;</td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_43" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td style="padding: 0px 5px;" align="center">
                <table class="tblText" border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="tblCell" style="padding: 20px; font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 14px; color: #383838; border-width: 1px; border-style: none; border-collapse: collapse; word-break: break-word;" align="left" valign="top">
                  <div style="line-height: 150%;">
                    <span style="font-family: 'Arial Black', 'Arial Bold', sans-serif;">MAKE KAKACLO YOUR NEW SECRET WEAPON IN FASHION BUSINESS</span>
                  </div>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr id="section_5" class="flexible-section" data-columns="1" data-section-type="bmeFooter">
    <td class="blk_container bmeHolder" style="color: #666666; border: 0px none transparent;" align="center" valign="top" bgcolor="timothywei@163.com" width="100%">
    <div id="dv_44" class="blk_wrapper">
    <table class="blk" style="background-color: #ffffff;" border="0" width="600" cellspacing="0" cellpadding="0">
    <tbody>
    <tr>
    <td class="tblCell" style="padding: 20px; word-break: break-word;" align="left" valign="top">
    <table border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
    <tr>
    <td style="text-align: center; word-break: break-word;" align="center">
      <span id="spnFooterText" style="font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 11px; line-height: 140%; color: #000000;"> <br />
      19H Maxgrand plaza No.3 Tai Yau Strect, Hong Kong, Hong Kong 518000, China</span> <br /><br />
      <span style="font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 11px; line-height: 140%; color: #000000;">
        <img title="Unsubscribe from all mailings" src="https://ui.benchmarkemail.com/images/verified.png" alt="Unsubscribe from all mailings" border="0" /> 
        <a class="bmefootertext" style="color: inherit; text-decoration: underline;" href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;email=NyIeD9VsXLU%3D&amp;relid=" target="_new">Unsubscribe</a> | 
        <a class="bmefootertext" style="color: inherit; text-decoration: underline;" href="https://clt1425789.bmetrack.com/c/s?e=14F8327&amp;c=15C17D&amp;t=1&amp;email=NyIeD9VsXLU%3D&amp;relid=" target="_new">Manage Subscription</a> 
        <br />
      </span>
    </td>
    </tr>
    </tbody>
    </table>
    </td>
    </tr>
    </tbody>
    </table>
    </div>
    </td>
    </tr>
  </tbody>
</table>`

export let emailTemplate2 = `
<table class="bmeMainColumn bmeHolder" style="max-width: 600px; overflow: visible; border-radius: 0px; border-collapse: separate; border-spacing: 0px;" border="0" cellspacing="0" cellpadding="0" align="center">
  <tbody>
    <tr id="section_1" class="flexible-section" data-columns="1" data-section-type="bmePreHeader">
      <td class="blk_container bmeHolder" style="color: #666666; border: 0px none transparent;" align="center" valign="top" bgcolor="" width="100%">&nbsp;</td>
    </tr>
    <tr>
      <td class="bmeHolder" style="border: 0px none transparent; border-radius: 0px; border-collapse: separate; border-spacing: 0px; overflow: hidden;" align="center" valign="top" width="100%">
        <table style="border-radius: 0px; border-collapse: separate; border-spacing: 0px; border: 0px none transparent; overflow: visible;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center">
          <tbody>
            <tr id="section_4" class="flexible-section" data-columns="1">
              <td class="blk_container bmeHolder" style="color: #383838; border: 0px none transparent; background-color: #ffffff;" align="center" valign="top" bgcolor="#ffffff" width="100%">
                <div id="dv_4" class="blk_wrapper">
                  <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                    <tbody>
                    <tr>
                    <td>
                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                    <tr>
                    <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                      <div>
                        <div>
                          <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/email1.png">
                        </div>
                        <div style="height: 48px;line-height: 48px;font-weight: bold;font-size:18px">
                          <span style="color:#99c41c">$25 OFF</span> OVER $50 CODE:SAVE25
                        </div>
                        <div style="background-color:#171717;height:350px;position: relative;padding-top: 80px;">
                          <div style="margin-bottom:30px;width:100%">
                            <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/emailCar1.png" style="height:60px;width:60px;display:block;margin:0 auto;">
                          </div>
                          <div style="color:#FFFFFF;font-size:24px;line-height:30px;margin-bottom:8px">
                            Don't you. forget about me!
                          </div>
                          <div style="color:#FFFFFF;font-size:14px;width:420px;line-height:20px">
                            Hey, you left something behind. Complete your order today for
                            an extra $25 off (just because we love you).
                          </div>
                        </div>
                      </div>
                    </td>
                    </tr>
                    </tbody>
                    </table>
                    </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div id="dv_8" class="blk_wrapper">
                  <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td>
                        <table border="0" width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                        <tr>
                        <td  style="border-collapse: collapse; padding: 0px;" align="center">
                          <div style="margin: 20px auto">
                              <h2 style="text-align:center;width:100%">YOUR ORDER</h2>
                              <div  class="kakaclo-for-productBasicInfoVOList">
                                <div style="margin: 22px 0 26px;display: flex;justify-content: center;">
                                  <div style="width: 116px;height:146px;background: #D9D9D9;font-weight: bold;margin-right:20px;text-align: center;line-height: 146px;">
                                    \${imageUrl}
                                  </div>
                                  <div style="font-size:8px;margin-top: 24px;text-align: left;width:200px">
                                    <p style="margin-bottom: 4px;white-space: nowrap;">\${productTitle}</p>
                                    <div style="color: #8B93A3;margin-bottom: 4px">\${option}</div>
                                    <p>
                                      <span>$\${price}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div style="width: 210px;line-height:36px;color:#fff;background-color:#99C41C;font-size: 14px">
                                <a href="https://mall.kakaclo.com/mall/shoppingCar" style="text-decoration: none;color: #fff">Check-out now</a>
                              </div>
                            </div>
                        </td>
                        </tr>
                        </tbody>
                        </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div id="dv_10" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <!-- <a href="https://clt1425789.bmetrack.com/c/l?u=E555663&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=3" target="_blank" rel="noopener"> -->
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819835.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  <!-- </a> -->
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_11" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <a href="https://mall.kakaclo.com/return&refund" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819840.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_3" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <a href="http://www.cxes.site/1HzwCea5" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819832.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_2" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImage" style="border-collapse: collapse; padding: 0px;" align="center">
                  <!-- <a href="https://clt1425789.bmetrack.com/c/l?u=E555663&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=6" target="_blank" rel="noopener"> -->
                    <img class="mobile-img-large" style="max-width: 1080px; display: block; border-radius: 0px;" src="https://images.benchmarkemail.com/client1425789/image12819846.jpg" alt="timothywei@163.com" width="600" border="0" data-radius="0" />
                  <!-- </a> -->
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_9" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>
                <table class="bmeGroupContainer" style="border-collapse: separate; border-width: 0px; border-style: none; border-color: rgba(0, 0, 0, 0); padding: 0px;" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="bmeImageContainerRow" valign="top">
                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="left">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555664&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819845.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="left">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555665&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819847.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                <th class="tdPart" align="center" valign="top">
                <table class="bmeImageTable" style="height: 101.656px;" border="0" width="200" cellspacing="0" cellpadding="0" align="right">
                <tbody>
                <tr>
                <td align="center" valign="top">
                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555666&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;seq=1" target="_blank" rel="noopener">
                    <img class="mobile-img-large" style="max-width: 360px; border-radius: 0px; display: block;" src="https://images.benchmarkemail.com/client1425789/image12819844.jpg" alt="timothywei@163.com" width="200" data-radius="0" />
                  </a>
                </td>
                </tr>
                </tbody>
                </table>
                </th>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_34" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="tblCellMain" style="padding: 10px 0px;">
                <table class="tblLine" style="border-top-width: 4px; border-top-color: #282828; border-top-style: solid; min-width: 1px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td>&nbsp;</td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
                <div id="dv_43" class="blk_wrapper">
                <table class="blk" border="0" width="600" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td style="padding: 0px 5px;" align="center">
                <table class="tblText" border="0" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                <tr>
                <td class="tblCell" style="padding: 20px; font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 14px; color: #383838; border-width: 1px; border-style: none; border-collapse: collapse; word-break: break-word;" align="left" valign="top">
                  <div style="line-height: 150%;">
                    <span style="font-family: 'Arial Black', 'Arial Bold', sans-serif;">MAKE KAKACLO YOUR NEW SECRET WEAPON IN FASHION BUSINESS</span>
                  </div>
                </td>
                </tr>
                </tbody>
                </table>
                </td>
                </tr>
                </tbody>
                </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr id="section_5" class="flexible-section" data-columns="1" data-section-type="bmeFooter">
    <td class="blk_container bmeHolder" style="color: #666666; border: 0px none transparent;" align="center" valign="top" bgcolor="timothywei@163.com" width="100%">
    <div id="dv_44" class="blk_wrapper">
    <table class="blk" style="background-color: #ffffff;" border="0" width="600" cellspacing="0" cellpadding="0">
    <tbody>
    <tr>
    <td class="tblCell" style="padding: 20px; word-break: break-word;" align="left" valign="top">
    <table border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
    <tr>
    <td style="text-align: center; word-break: break-word;" align="center">
      <span id="spnFooterText" style="font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 11px; line-height: 140%; color: #000000;"> <br />
      19H Maxgrand plaza No.3 Tai Yau Strect, Hong Kong, Hong Kong 518000, China</span> <br /><br />
      <span style="font-family: Arial, Helvetica, sans-serif; font-weight: normal; font-size: 11px; line-height: 140%; color: #000000;">
        <img title="Unsubscribe from all mailings" src="https://ui.benchmarkemail.com/images/verified.png" alt="Unsubscribe from all mailings" border="0" /> 
        <a class="bmefootertext" style="color: inherit; text-decoration: underline;" href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;email=NyIeD9VsXLU%3D&amp;relid=" target="_new">Unsubscribe</a> | 
        <a class="bmefootertext" style="color: inherit; text-decoration: underline;" href="https://clt1425789.bmetrack.com/c/s?e=14F8327&amp;c=15C17D&amp;t=1&amp;email=NyIeD9VsXLU%3D&amp;relid=" target="_new">Manage Subscription</a> 
        <br />
      </span>
    </td>
    </tr>
    </tbody>
    </table>
    </td>
    </tr>
    </tbody>
    </table>
    </div>
    </td>
    </tr>
  </tbody>
</table>`

export let markShipmentTemplate = `<table name="bmeMainColumn" class="m_4087789853795438185bmeMainColumn m_4087789853795438185bmeHolder" cellspacing="0" cellpadding="0" border="0" align="center" style="color: rgb(34, 34, 34); font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; text-align: start; text-transform: none; white-space: normal; word-spacing: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; overflow: visible; border-radius: 0px; border-collapse: separate; border-spacing: 0px;">
<tbody>
  <tr>
    <td width="100%" class="m_4087789853795438185bmeHolder" valign="top" align="center" name="bmeMainContentParent" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border: 0px none transparent; border-radius: 0px; border-collapse: separate; border-spacing: 0px; overflow: hidden;">
      <table name="bmeMainContent" cellspacing="0" cellpadding="0" border="0" align="center" style="border-radius: 0px; border-collapse: separate; border-spacing: 0px; border: 0px none transparent; overflow: visible; width: 100%;">
        <tbody>
          <tr id="m_4087789853795438185section_4">
            <td width="100%" class="m_4087789853795438185blk_container m_4087789853795438185bmeHolder" name="bmePreFooter" valign="top" align="center" bgcolor="#ffffff" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; color: rgb(56, 56, 56); border: 0px none transparent; background-color: rgb(255, 255, 255);">
              <div id="m_4087789853795438185dv_4">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://mall.kakaclo.com/order/details?kkOrderId=\${kkOrderId}&orderStatus=\${orderStatus}" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAB%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw2p9YX6tleP4cTAZvXKXJS9" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci4.googleusercontent.com/proxy/QU631NNseX4cVCODTw2KPKi5imqqmoKkFc7t7T-maHUpvhatP2uifwqHLGM3PoXUaEpbqBSfJBIHOgNbNRcWq5ieQcOGaaaqHKcoXuJDqaAafR_d=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12964459.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_8">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <div style="padding:40px 20px">
                                  <div style="background-color:#F7F7F7;padding:40px 20px">
                                    <h3 style="margin-bottom: 10px">SUMMARY:</h3>
                                    <p style="font-size:16px;line-height:22px">Order No. : \${kkOrderId}</p>
                                    <p style="font-size:16px;line-height:22px">Order Date: \${purchaseDate}</p>
                                    <p style="font-size:16px;line-height:22px">Order Total: $\${finalAmount}</p>
                                    <p style="font-size:16px;line-height:22px">Tracking code: \${trackingNumber}</p>
                                    <hr style="margin: 30px 0">
                                    <h3 style="margin-bottom: 10px">SHIPPING ADDRESS:</h3>
                                    <p style="font-size:16px;line-height:22px"><span>\${street1}</span></p>
                                    <p style="font-size:16px;line-height:22px"><span style="margin-right:4px">\${street2}</span><span>\${city}</span></p>
                                    <p style="font-size:16px;line-height:22px"><span style="margin-right:4px">\${province}</span><span>\${country}</span></p>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_10">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <div>
                                  <div>
                                    <div style="background-color:#000000;color: #FDFDFD;display: flex;padding:12px 20px;margin: 0 20px;">
                                      <div style="font-size:18px;font-weight:bold;width:310px">ITEMS SHIPPED:</div>
                                      <div style="width:100px;font-size:16px;text-align: center;">QTY</div>
                                      <div style="width:110px;font-size:16px;text-align: center;">PRICE</div>
                                    </div>
                                    <div class="kakaclo-for-productBasicInfoVOList">
                                      <div style="display: flex;padding:12px 20px;margin: 0 20px;">
                                        <div style="width:120px;height:180px;font-weight: bold; margin-right: 20px; text-align: center; line-height: 180px;background-color: #D9D9D9;">
                                          \${imageUrl}
                                        </div>
                                        <div style="width:170px;word-break:break-all;display: flex;align-items:center">\${productTitle}</div>
                                        <div style="width:100px;text-align:center;line-height:180px">
                                          \${productNum}
                                        </div>
                                        <div style="color:#e4555b;width:110px;text-align:center;line-height:180px">$\${price}</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div style="width: 300px;line-height: 40px;text-align: center;background-color: #99C41C;border-radius: 3px;margin: 0 auto;cursor: pointer;">
                                    <a href="https://mall.kakaclo.com/order/details?kkOrderId=\${kkOrderId}&amp;orderStatus=\${orderStatus}" style="
                                        text-decoration: solid;
                                        color: #fff;
                                        width: 100%;
                                        height: 40px;
                                    ">\${viewMore}</a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_11">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAB&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAB%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D2&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1sY72Mnps3vLdvqpHyXXKD" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci5.googleusercontent.com/proxy/qzeKYfNWpEamwKycwYI-5xEngzu6ovL3yb65If7E6XSEQj3nJiTBTLxJxoJeDIwOdwNdaieplKizxmMc62qUFC533dZPLS-y98XS8C6UdN01NtKU=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12964462.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_1">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAC&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAC%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw02o0fMw_omZRK8zPTorSkB" style="color: rgb(17, 85, 204);">
                                  <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/home-img/6067127F-B60E-414C-940E-B8693DEA9F76.png" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_3">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAC&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAC%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D2&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw19yom6e-zCkBayJx64TYK_" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci4.googleusercontent.com/proxy/Nm_KeBO4QakNGyxg6DV3KfzC5aiXDoyeSAdCGga7afmZmEZG-WEkTRII-Mt4OBxwI5tXrU3OSZmqtMgfkA7urcJQmRxt43LIZemvP2CQy3b2rUev=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12964510.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_2">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://mall.kakaclo.com" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555663%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D3&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw0qnwA8E2CtiwIaRbrSqGk5" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci6.googleusercontent.com/proxy/U69RDYUlYOo2Splva3FbrqOYG3j0b_bNofOjFrazSRQ_NXz3zZE7kLDGjrbvoshXvWF-adhpFZblFsQHS_VU9MmYRdiCefWNkFt7zSZ5vnOXW9o3=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819846.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_9">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_group" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" style="border-collapse: separate; padding: 0px; border-width: 0px; border-style: none; border-color: rgba(0, 0, 0, 0); width: 100%;">
                          <tbody>
                            <tr>
                              <td valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                                  <tbody>
                                    <tr>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="left" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555664&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555664%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1tYOAMMUlPNPu6VdTpN_g7" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci4.googleusercontent.com/proxy/lm1sM-UOyDl_eA0i6z3BcUsMiF0VmYDMCoavJbDwTgNmsjRpWsGv02QqX8qIDbfXs96rYZ_F3blvH77mLG_mOwFyDea-hb_Lg-7NsinPx1062djS=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819845.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="left" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555665&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555665%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1EEUqCjieTRKF6DMhHlBcL" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci3.googleusercontent.com/proxy/lykVKaNcf0VoBmw7415kMEVaRdA_i6WSug22bbMG1whiJC10MmqGRZZeu90PpZGsXbn6dbx-zW43Ld0xqwv-yyYi6FjodmHnZvd6OTq0tebwcROW=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819847.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="right" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555666&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555666%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw3NpXQbRU-mmFYk0QI4BjwP" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci5.googleusercontent.com/proxy/gH0kyfRV3-kqvnLVmd0sgEcuOI_J0bbz98RoTpS8SStoBQcTAP3ZHimb4nMM4dS0rUhPTWeR_4o69MfMrljYcXaOXGwSM18MS6ALCwb_oF3TX7qK=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819844.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_34">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_divider" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; padding: 10px 0px;">
                        <table class="m_4087789853795438185tblLine" cellspacing="0" cellpadding="0" border="0" style="border-top: 4px solid rgb(40, 40, 40); width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;"></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="clear: both"></div>
    </td>
  </tr>
  <tr id="m_4087789853795438185section_5">
    <td width="100%" class="m_4087789853795438185blk_container m_4087789853795438185bmeHolder" name="bmeFooter" valign="top" align="center" bgcolor="timothywei@163.com" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; color: rgb(102, 102, 102); border: 0px none transparent;">
      <div id="m_4087789853795438185dv_44">
        <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_footer" style="background-color: rgb(255, 255, 255); width: 600px;">
          <tbody>
            <tr>
              <td name="tblCell" class="m_4087789853795438185tblCell" valign="top" align="left" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; padding: 20px; word-break: break-word;">
                <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td name="bmeBadgeText" align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; word-break: break-word;">
                        <span id="m_4087789853795438185spnFooterText" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; font-size: 11px; line-height: 16.8px; color: rgb(0, 0, 0);">
                          <br>19H Maxgrand plaza No.3 Tai Yau Strect, Hong Kong, Hong Kong 518000, China</span>
                        <br>
                        <br>
                        <span style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; font-size: 11px; line-height: 16.8px; color: rgb(0, 0, 0);">
                          <span href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=">
                            <img src="https://ci6.googleusercontent.com/proxy/UTGJ_4UxWqzw7HMWWbIoHBFlNZQSRAfKG_ollecDb7AoyXbvuOvOBWQJIiQROVNJKFsDQaqwXTmtLcbZoQ4G-t0jT8Y=s0-d-e1-ft#https://ui.benchmarkemail.com/images/verified.png" alt="Unsubscribe from all mailings" title="Unsubscribe from all mailings" border="0" class="CToWUd" data-bit="iit" style="vertical-align: bottom;">
                          </span>
                          <span>&nbsp;</span>
                          <a href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/su?e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26relid%3D&amp;source=gmail&amp;ust=1665741377103000&amp;usg=AOvVaw1MAdeihqZwOGVARy_Ch48i" style="color: inherit; text-decoration: underline;">Unsubscribe</a>
                          <span>&nbsp;</span>|<span>&nbsp;</span>
                          <a href="https://clt1425789.bmetrack.com/c/s?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/s?e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26relid%3D&amp;source=gmail&amp;ust=1665741377103000&amp;usg=AOvVaw0fW_iUyIjrV7JaQTPtMUK5" style="color: inherit; text-decoration: underline;">Manage Subscription</a>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
</tbody>
</table>`

export let afterPaymentTemplate = `
<table name="bmeMainColumn" class="m_4087789853795438185bmeMainColumn m_4087789853795438185bmeHolder" cellspacing="0" cellpadding="0" border="0" align="center" style="color: rgb(34, 34, 34); font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; text-align: start; text-transform: none; white-space: normal; word-spacing: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; overflow: visible; border-radius: 0px; border-collapse: separate; border-spacing: 0px;">
<tbody>
  <tr>
    <td width="100%" class="m_4087789853795438185bmeHolder" valign="top" align="center" name="bmeMainContentParent" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border: 0px none transparent; border-radius: 0px; border-collapse: separate; border-spacing: 0px; overflow: hidden;">
      <table name="bmeMainContent" cellspacing="0" cellpadding="0" border="0" align="center" style="border-radius: 0px; border-collapse: separate; border-spacing: 0px; border: 0px none transparent; overflow: visible; width: 100%;">
        <tbody>
          <tr id="m_4087789853795438185section_4">
            <td width="100%" class="m_4087789853795438185blk_container m_4087789853795438185bmeHolder" name="bmePreFooter" valign="top" align="center" bgcolor="#ffffff" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; color: rgb(56, 56, 56); border: 0px none transparent; background-color: rgb(255, 255, 255);">
              <div id="m_4087789853795438185dv_4">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://mall.kakaclo.com/order/details?kkOrderId=\${kkOrderId}&orderStatus=\${orderStatus}" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAB%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw2p9YX6tleP4cTAZvXKXJS9" style="color: rgb(17, 85, 204);">
                                  <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/tapd_60326880_base64_1668414440_52.png" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_8">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <div style="padding:40px 20px">
                                  <div style="background-color:#F7F7F7;padding:40px 20px">
                                    <h3 style="margin-bottom: 10px">SUMMARY:</h3>
                                    <p style="font-size:16px;line-height:22px">Order No. : \${kkOrderId}</p>
                                    <p style="font-size:16px;line-height:22px">Order Date: \${purchaseDate}</p>
                                    <p style="font-size:16px;line-height:22px">Order Total: $\${finalAmount}</p>
                                    <hr style="margin: 30px 0">
                                    <h3 style="margin-bottom: 10px">SHIPPING ADDRESS:</h3>
                                    <p style="font-size:16px;line-height:22px"><span>\${street1}</span></p>
                                    <p style="font-size:16px;line-height:22px"><span style="margin-right:4px">\${street2}</span><span>\${city}</span></p>
                                    <p style="font-size:16px;line-height:22px"><span style="margin-right:4px">\${province}</span><span>\${country}</span></p>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_10">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <div>
                                  <div>
                                    <div style="background-color:#000000;color: #FDFDFD;display: flex;padding:12px 20px;margin: 0 20px;">
                                      <div style="font-size:18px;font-weight:bold;width:310px">ITEMS SHIPPED:</div>
                                      <div style="width:100px;font-size:16px;text-align: center;">QTY</div>
                                      <div style="width:110px;font-size:16px;text-align: center;">PRICE</div>
                                    </div>
                                    <div class="kakaclo-for-productBasicInfoVOList">
                                      <div style="display: flex;padding:12px 20px;margin: 0 20px;">
                                        <div style="width:120px;height:180px;font-weight: bold; margin-right: 20px; text-align: center; line-height: 180px;background-color: #D9D9D9;">
                                          \${imageUrl}
                                        </div>
                                        <div style="width:170px;word-break:break-all;display: flex;align-items:center">\${productTitle}</div>
                                        <div style="width:100px;text-align:center;line-height:180px">
                                          \${productNum}
                                        </div>
                                        <div style="color:#e4555b;width:110px;text-align:center;line-height:180px">$\${price}</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div style="width: 300px;line-height: 40px;text-align: center;background-color: #99C41C;border-radius: 3px;margin: 0 auto;cursor: pointer;">
                                    <a href="https://mall.kakaclo.com/order/details?kkOrderId=\${kkOrderId}&amp;orderStatus=\${orderStatus}" style="
                                        text-decoration: solid;
                                        color: #fff;
                                        width: 100%;
                                        height: 40px;
                                    ">\${viewMore}</a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_11">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAB&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAB%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D2&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1sY72Mnps3vLdvqpHyXXKD" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci5.googleusercontent.com/proxy/qzeKYfNWpEamwKycwYI-5xEngzu6ovL3yb65If7E6XSEQj3nJiTBTLxJxoJeDIwOdwNdaieplKizxmMc62qUFC533dZPLS-y98XS8C6UdN01NtKU=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12964462.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_1">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAC&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAC%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw02o0fMw_omZRK8zPTorSkB" style="color: rgb(17, 85, 204);">
                                  <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/home-img/6067127F-B60E-414C-940E-B8693DEA9F76.png" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_3">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://clt1425789.bmetrack.com/c/l?u=E75EFAC&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE75EFAC%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D2&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw19yom6e-zCkBayJx64TYK_" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci4.googleusercontent.com/proxy/Nm_KeBO4QakNGyxg6DV3KfzC5aiXDoyeSAdCGga7afmZmEZG-WEkTRII-Mt4OBxwI5tXrU3OSZmqtMgfkA7urcJQmRxt43LIZemvP2CQy3b2rUev=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12964510.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_2">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_image" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                          <tbody>
                            <tr>
                              <td align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; border-collapse: collapse; padding: 0px;">
                                <a href="https://mall.kakaclo.com" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555663%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D3&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw0qnwA8E2CtiwIaRbrSqGk5" style="color: rgb(17, 85, 204);">
                                  <img src="https://ci6.googleusercontent.com/proxy/U69RDYUlYOo2Splva3FbrqOYG3j0b_bNofOjFrazSRQ_NXz3zZE7kLDGjrbvoshXvWF-adhpFZblFsQHS_VU9MmYRdiCefWNkFt7zSZ5vnOXW9o3=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819846.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="600" alt="Order is on its way" border="0" data-bit="iit" style="max-width: 1080px; border-radius: 0px; vertical-align: bottom;">
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_9">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_group" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                        <table cellspacing="0" cellpadding="0" style="border-collapse: separate; padding: 0px; border-width: 0px; border-style: none; border-color: rgba(0, 0, 0, 0); width: 100%;">
                          <tbody>
                            <tr>
                              <td valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                                  <tbody>
                                    <tr>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="left" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555664&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555664%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1tYOAMMUlPNPu6VdTpN_g7" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci4.googleusercontent.com/proxy/lm1sM-UOyDl_eA0i6z3BcUsMiF0VmYDMCoavJbDwTgNmsjRpWsGv02QqX8qIDbfXs96rYZ_F3blvH77mLG_mOwFyDea-hb_Lg-7NsinPx1062djS=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819845.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="left" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555665&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555665%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw1EEUqCjieTRKF6DMhHlBcL" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci3.googleusercontent.com/proxy/lykVKaNcf0VoBmw7415kMEVaRdA_i6WSug22bbMG1whiJC10MmqGRZZeu90PpZGsXbn6dbx-zW43Ld0xqwv-yyYi6FjodmHnZvd6OTq0tebwcROW=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819847.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                      <td valign="top" align="center" class="m_4087789853795438185tdPart">
                                        <div style="font-weight: 700; text-align: center;">
                                          <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185bmeImageTable" align="right" style="width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td name="bmeImgHolder" align="center" valign="top" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;">
                                                  <a href="https://clt1425789.bmetrack.com/c/l?u=E555666&amp;e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;seq=1" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/l?u%3DE555666%26e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26seq%3D1&amp;source=gmail&amp;ust=1665741377102000&amp;usg=AOvVaw3NpXQbRU-mmFYk0QI4BjwP" style="color: rgb(17, 85, 204);">
                                                    <img src="https://ci5.googleusercontent.com/proxy/gH0kyfRV3-kqvnLVmd0sgEcuOI_J0bbz98RoTpS8SStoBQcTAP3ZHimb4nMM4dS0rUhPTWeR_4o69MfMrljYcXaOXGwSM18MS6ALCwb_oF3TX7qK=s0-d-e1-ft#https://images.benchmarkemail.com/client1425789/image12819844.jpg" class="m_4087789853795438185mobile-img-large CToWUd" width="200" alt="timothywei@163.com" data-bit="iit" style="max-width: 360px; border-radius: 0px; vertical-align: bottom;">
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div style="clear: both"></div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="m_4087789853795438185dv_34">
                <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_divider" style="width: 600px;">
                  <tbody>
                    <tr>
                      <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; padding: 10px 0px;">
                        <table class="m_4087789853795438185tblLine" cellspacing="0" cellpadding="0" border="0" style="border-top: 4px solid rgb(40, 40, 40); width: 100%;">
                          <tbody>
                            <tr>
                              <td style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px;"></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="clear: both"></div>
    </td>
  </tr>
  <tr id="m_4087789853795438185section_5">
    <td width="100%" class="m_4087789853795438185blk_container m_4087789853795438185bmeHolder" name="bmeFooter" valign="top" align="center" bgcolor="timothywei@163.com" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; color: rgb(102, 102, 102); border: 0px none transparent;">
      <div id="m_4087789853795438185dv_44">
        <table cellspacing="0" cellpadding="0" border="0" class="m_4087789853795438185blk" name="blk_footer" style="background-color: rgb(255, 255, 255); width: 600px;">
          <tbody>
            <tr>
              <td name="tblCell" class="m_4087789853795438185tblCell" valign="top" align="left" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; padding: 20px; word-break: break-word;">
                <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td name="bmeBadgeText" align="center" style="font-family: &quot;Google Sans&quot;, Roboto, RobotoDraft, Helvetica, Arial, sans-serif; margin: 0px; word-break: break-word;">
                        <span id="m_4087789853795438185spnFooterText" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; font-size: 11px; line-height: 16.8px; color: rgb(0, 0, 0);">
                          <br>19H Maxgrand plaza No.3 Tai Yau Strect, Hong Kong, Hong Kong 518000, China</span>
                        <br>
                        <br>
                        <span style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; font-size: 11px; line-height: 16.8px; color: rgb(0, 0, 0);">
                          <span href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=">
                            <img src="https://ci6.googleusercontent.com/proxy/UTGJ_4UxWqzw7HMWWbIoHBFlNZQSRAfKG_ollecDb7AoyXbvuOvOBWQJIiQROVNJKFsDQaqwXTmtLcbZoQ4G-t0jT8Y=s0-d-e1-ft#https://ui.benchmarkemail.com/images/verified.png" alt="Unsubscribe from all mailings" title="Unsubscribe from all mailings" border="0" class="CToWUd" data-bit="iit" style="vertical-align: bottom;">
                          </span>
                          <span>&nbsp;</span>
                          <a href="https://clt1425789.bmetrack.com/c/su?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/su?e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26relid%3D&amp;source=gmail&amp;ust=1665741377103000&amp;usg=AOvVaw1MAdeihqZwOGVARy_Ch48i" style="color: inherit; text-decoration: underline;">Unsubscribe</a>
                          <span>&nbsp;</span>|<span>&nbsp;</span>
                          <a href="https://clt1425789.bmetrack.com/c/s?e=14F8327&amp;c=15C17D&amp;t=1&amp;l=848FAF33&amp;email=lQBtL2Cz731uKJRooaPTbpemkgBQcCdv&amp;relid=" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://clt1425789.bmetrack.com/c/s?e%3D14F8327%26c%3D15C17D%26t%3D1%26l%3D848FAF33%26email%3DlQBtL2Cz731uKJRooaPTbpemkgBQcCdv%26relid%3D&amp;source=gmail&amp;ust=1665741377103000&amp;usg=AOvVaw0fW_iUyIjrV7JaQTPtMUK5" style="color: inherit; text-decoration: underline;">Manage Subscription</a>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
</tbody>
</table>`

export let publishTemplate = `
<table style="border-collapse: collapse; width: 85.1315%; height: 63px;" border="1">
  <tbody class="trFather">
    <tr style="height: 21px;">
      <td style="width: 220px; height: 21px; text-align: center;"><span style="color: #000000;">Photo</span></td>
      <td style="width: 29.1627%; height: 21px; text-align: center;"><span style="color: #000000;">Product Title</span></td>
      <td style="width: 32.1537%; height: 21px; text-align: center;"><span style="color: #000000;">Sku</span></td>
    </tr>
    <tr class="kakaclo-for-spuRemovedVOList" style="height: 21px;">
      <td style="width: 220px; height: 21px; text-align: center;"><span style="color: #000000;">\${photo}</span></td>
      <td style="width: 29.1627%; height: 21px; text-align: center;"><span style="color: #000000;">\${productTitle}</span></td>
      <td style="width: 32.1537%; height: 21px; text-align: center;"><span style="color: #000000;">\${sku}</span></td>
    </tr>
  </tbody>
</table>
<div style="width: 300px; line-height: 40px; text-align: center; background-color: #99c41c; border-radius: 3px; cursor: pointer;">
  <a style="text-decoration: solid; color: #fff;width: 100%;height: 40px;" href="https://mall.kakaclo.com/publish/listings?skuCodeStatus=4,0&platformCode=\${platformCode}">\${viewMore}</a>
</div>
`

export let afterProductInfoPayment = `
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">【IMPORTANT】The product information you uploaded has changed</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">Hey \${userName},&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">We hope that this e-mail finds you well.&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">We regret to inform you that the product information of pictures/size chart/variants you uploaded has changed.</p>
<table style="border-collapse: collapse; width: 85.1315%; height: 63px;" border="1">
<tbody class="trFather">
<tr style="height: 21px;">
<td style="width: 220px; height: 21px; text-align: center;"><span style="color: #000000;">Photo</span></td>
<td style="width: 29.1627%; height: 21px; text-align: center;"><span style="color: #000000;">Product Title</span></td>
<td style="width: 32.1537%; height: 21px; text-align: center;"><span style="color: #000000;">Item No</span></td>
</tr>
<tr class="kakaclo-for-spuRemovedVOList" style="height: 21px;">
<td style="width: 220px; height: 21px; text-align: center;"><span style="color: #000000;">\${photo}</span></td>
<td style="width: 29.1627%; height: 21px; text-align: center;"><span style="color: #000000;">\${productTitle}</span></td>
<td style="width: 32.1537%; height: 21px; text-align: center;"><span style="color: #000000;">\${spu}</span></td>
</tr>
</tbody>
</table>
<div style="width: 300px; line-height: 40px; text-align: center; background-color: #99c41c; border-radius: 3px; cursor: pointer;"><a style="text-decoration: solid; color: #fff;display: block;width: 100%;height: 40px;" href="https://mall.kakaclo.com/publish/listings?activeName=WaitingForUpdate">\${viewMore}</a></div>
<div>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">We kindly suggest that you could delete it from your store and upload it again to ensure your product information is up to date.</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">If you have any questions, please don't hesitate to ask.&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">Best regards,</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">&nbsp;</p>
<p style="word-break: break-word; margin-top: 0px; margin-bottom: 0px; padding: 0px; list-style: none; line-height: 22px; cursor: text; color: #182b50; font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif; font-size: 14px;">KakaClo Support Team</p>
</div>
`

